<template>
	<button
		type="button"
		class="counter__button"
		:class="`counter__button--${type}`"
		:disabled="props.disabled"
		@click="onClick"
	>
	</button>
</template>

<script setup lang="ts">
interface Props {
	type: 'increment' | 'decrement';
	disabled?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits<{
	(event: 'buttonClick', type: Props['type']): void;
}>();

const onClick = () => emit('buttonClick', props.type);
</script>
